import React from 'react';
import './VideoCallout.scss';
import { KiteGrid, KiteGridCell } from '@kite/react-kite';

export interface VideoCalloutInputs {
    title: string;
    text: string;
    video: string;
    bgColor: string;
    imagePosition: string;
    name?: string;
}

export const VideoCallout = ({ inputs }: { inputs: VideoCalloutInputs }) => {
    return (
        <section
            className={`paragraph__video_callout ${inputs.imagePosition} ${inputs.bgColor}`}
        >
            <div className="kite-container">
                <KiteGrid>
                    <KiteGridCell col={7} className="video">
                        <iframe
                            src={`https://www.youtube.com/embed/${inputs.video}`}
                            title={inputs.name ?? `YouTube video player`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </KiteGridCell>
                    <KiteGridCell col={5}>
                        <h2>{inputs.title}</h2>
                        <div
                            className="content"
                            dangerouslySetInnerHTML={{ __html: inputs.text }}
                        ></div>
                    </KiteGridCell>
                </KiteGrid>
            </div>
        </section>
    );
};
